/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import { Account, AccountAddRequest } from '../../../../ts/account';
import { endpoints } from '../../util/config';

const endpoint = (id: string) => urlJoin(`${endpoints.bluemix}/accounts`, id);

// NOTE current use of this POST is not using the return response, only the success/fail
// so for now return typed as `any`
export const addUsersToAccount = async (
  id: string,
  addUserData: AccountAddRequest
): Promise<any> => {
  const response = await axios.post(
    urlJoin(endpoint(id), 'users'),
    addUserData
  );
  return response.data;
};

export async function getAccount(id: string): Promise<Account> {
  const resp = await axios.get(endpoint(id));
  return resp.data;
}
